const Header = ( props ) => {
	return (
		<header>
			<h1 className="page-title">{ props.title }</h1>
		</header>
	)
}

export default Header;
